import { parseTime } from '@/utils/util'
export const searchForm = {
  line_id: undefined,
  project: undefined,
  staff_style: undefined,
  type: undefined,
  keyword: undefined,
  status: undefined,
  creator: undefined,
  created_at: [],
  updator: undefined,
  update_at: [],
  id: undefined
}

export const form = {
  line_id: undefined, // 发布平台
  project: undefined,
  staff_style: undefined,
  type: undefined,
  keyword: [], // 关键词
  url: undefined,
  status: 1
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  keyword: [{ required: true, message: '请输入关键词', trigger: 'change' }],
  url: [{ required: true, message: '请输入关联网址', trigger: 'change' }],
  status: [{ required: true, message: '请输入', trigger: 'change' }],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    align: 'left',
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '推荐关键词',
    dataIndex: 'keyword',
    width: 200,
    align: 'left',
  },
  {
    title: '关联显示网址',
    dataIndex: 'url',
    align: 'center',
    width: 220,
    scopedSlots: { customRender: 'url' }
  },
  {
    title: '相关人员',
    dataIndex: 'creator',
    align: 'left',
    width: 220,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '相关时间',
    dataIndex: 'created_at',
    width: 220,
    align: 'left',
    scopedSlots: { customRender: 'created_at' }
    // customRender(text) {
    //   text === 0 ? text = '--' : text = parseTime(text)
    //   return text
    // }
  },
  {
    title: '是否生效',
    dataIndex: 'status',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'operator' }
  }
]

// export const columnsArticle = [
//   {
//     title: '序号',
//     dataIndex: 'id',
//     width: 100,
//     align: 'center'
//   },
//   {
//     title: '标题',
//     dataIndex: 'article',
//     width: 160,
//     align: 'left',
//     scopedSlots: { customRender: 'title' }
//   },
//   {
//     title: '文章分类',
//     dataIndex: 'article.typeid',
//     width: 100,
//     align: 'left',
//     scopedSlots: { customRender: 'typeid' }
//   },
//   {
//     title: '发布时间',
//     dataIndex: 'article.created_at',
//     align: 'left',
//     width: 120,
//     customRender(text) {
//       return parseTime(text)
//     }
//   },
//   {
//     title: '发布人',
//     dataIndex: 'article.add_person_name',
//     width: 120,
//     align: 'left',
//     scopedSlots: { customRender: 'add_person_name' }
//   },
//   {
//     title: '操作',
//     dataIndex: 'operator',
//     align: 'center',
//     width: 50,
//     scopedSlots: { customRender: 'operator' }
//   }
// ]
